import Banner from 'components/Banner';
import { data } from './mockdata';
import GradientText from 'components/GradientText';
import resourcesBanner from 'images/resourcesBanner.jpg';
import ProductCards from 'components/ProductCards/index';
import image from 'images/small-images-inside-text/Image.jpg';
import ProductSideBar from 'components/ProductSideBar';

const Resources = () => {
    return (
        <div className="container">
            <div>
                <Banner title="Resources" image={resourcesBanner} buttonText="LEARN MORE" />
                <ProductSideBar />
                <GradientText>
                    Discover valuable resources
                    <br />
                    <em>
                        to enhance your <img src={image} alt="decor" /> agricultural journey
                    </em>
                </GradientText>
                <div className="offset-left-4 max-width-760">
                    <GradientText size="small">
                        Explore our{' '}
                        <em>
                            complex crop nutrition programs and the results
                            <br />
                            of our trials
                        </em>{' '}
                        to learn how to care for your plants for optimal yields.
                    </GradientText>
                </div>
                <ProductCards data={data} />
            </div>
        </div>
    );
};

export default Resources;
